import { render, staticRenderFns } from "./BigCarousel.vue?vue&type=template&id=0bd31976&scoped=true&"
import script from "./BigCarousel.vue?vue&type=script&lang=js&"
export * from "./BigCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BigCarousel.vue?vue&type=style&index=0&id=0bd31976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd31976",
  null
  
)

export default component.exports